/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DjRestAuthUser } from '../models/DjRestAuthUser';
import type { InvitationRead } from '../models/InvitationRead';
import type { InvitationResend } from '../models/InvitationResend';
import type { InvitationWrite } from '../models/InvitationWrite';
import type { PaginatedInvitationReadList } from '../models/PaginatedInvitationReadList';
import type { PatchedInvitationWrite } from '../models/PatchedInvitationWrite';
import type { UserRegistrationWithInvitation } from '../models/UserRegistrationWithInvitation';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InvitationService {

    /**
     * Copy of django-rest-framework's `ListAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns PaginatedInvitationReadList
     * @throws ApiError
     */
    public static invitationList({
        groupNamesIn,
        limit,
        offset,
        search,
    }: {
        groupNamesIn?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        search?: string,
    }): CancelablePromise<PaginatedInvitationReadList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/invitation/',
            query: {
                'group_names__in': groupNamesIn,
                'limit': limit,
                'offset': offset,
                'search': search,
            },
        });
    }

    /**
     * Copy of django-rest-framework's `ListAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationCreate({
        requestBody,
    }: {
        requestBody: InvitationRead,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/invitation/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/invitation/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: InvitationWrite,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/invitation/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedInvitationWrite,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/invitation/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns void
     * @throws ApiError
     */
    public static invitationDestroy({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/invitation/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationResendUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: InvitationResend,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/invitation/{id}/resend',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns InvitationRead
     * @throws ApiError
     */
    public static invitationFromTokenRetrieve({
        token,
    }: {
        token: string,
    }): CancelablePromise<InvitationRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/invitation/from-token/{token}/',
            path: {
                'token': token,
            },
        });
    }

    /**
     * @returns DjRestAuthUser
     * @throws ApiError
     */
    public static invitationRegisterCreate({
        requestBody,
    }: {
        requestBody: UserRegistrationWithInvitation,
    }): CancelablePromise<DjRestAuthUser> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/invitation/register/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
